export enum IncidentType {
  AA = "AA-1",
  BP = "BP-2",
  CH = "CH-3",
  DE = "DE-4",
  EL = "EL-5",
  EQ = "EQ-6",
  FA = "FA-7",
  IU = "IU-8",
  MI = "MI-9",
  PD = "PD-10",
  SK = "SK-11",
  OT = "OT-12",
}

export enum IncidentStatus {
  Draft = "Draft",
  Submitted = "Submitted",
  Open = "Open",
  SignatoryInProgress = "Signature in Progress",
  ReadyForApproval = "Ready for Approval",
  Completed = "Completed",
}

export enum TabOptions {
  Approvals = "Approvals",
  Conclusion = "Conclusion",
  Details = "Details",
  Factors = "Factors",
  PatientDemographics = "Patient Demographics",
  Statements = "Statements",
  Response = "Response",
  Attachments = "Attachments",
}

export enum FieldTypes {
  Text = "Text",
  TextArea = "TextArea",
  Number = "Number / Currency",
  DateTime = "Date/Time",
  Picklist = "Picklist",
  Lookup = "Lookup",
  TextWithLabel = "TextWithLabel",
  CustomBPField = "CustomBPField",
  CustomWoundComp = "CustomWoundComp",
  RadioButtons = "Radio Buttons",
  Checkbox = "Checkbox",
  Togglebox = "Togglebox",
  MultiSelectPicklist = "Multi-Select Picklist",
  MultiSelectasCheckBoxes = "Multi-Select as CheckBoxes",
  BranchedMultiSelectasCheckBoxes = "Branched Multi-Select as CheckBoxes",
  RelatedList = "RelatedList",
  InlineRelatedList = "InlineRelatedList",
}

type tabInstance = [IncidentType, TabOptions];

export interface DateConstraint {
  min?: string;
  max?: string;
}

export interface IFieldInstance {
  id: string;
  fieldName: string;
  parentFieldId: string;
  childFieldIds: string[];
  tab: tabInstance[] | any[];
  incidentType: IncidentType[];
  section: string;
  fieldLabel: string | undefined;
  condition: string | string[];
  fieldType: string;
  dataType: string;
  unit: string;
  values: string[];
  valueLabels: string[];
  required: boolean;
  searchable: boolean;
  tableLabel?: string;
  qapi: boolean;
  // Required only for new/draft incidents; optional once already submitted (MARCC-772).
  requiredForNewIncidentOnly?: boolean;
  constraint?: DateConstraint | null;
  askConfirmation?: boolean;
  "data-testid"?: string;
}
